<template>
    <div>
        <div class="container" style="width:100%;">
            <div style="font-size:20px;"><i class="el-icon-s-unfold grid-con-icon"></i><span style="margin-left:5px;">代理商信息</span></div>
            <el-form :model="form" inline  style="padding-left:8px;margin-top:10px;">
                <!-- <div style="display:flex;justify-content:flex-end;">
                    <el-button @click="onEditClick(null)" type="primary">新建客户</el-button>
                </div>                 -->
                <el-row>
                    <el-form-item label="关键字">
						<el-input v-model="form.key" class="text-width"></el-input>
					</el-form-item>
                    <el-button @click="onQuery" type="primary">检索</el-button>
                </el-row>
            </el-form>
            <el-table 
                :data="agentList.slice((currentPage-1)*PageSize,currentPage*PageSize)" 
                border :header-cell-style="{background:'#eef1f6',color:'#606266'}" 
                        style="width: 80%;margin-top: 10px;" ref="Table" >
                <el-table-column prop="agentName" align="center" label="终端客户"></el-table-column>   
                <el-table-column prop="agentCode" align="center"  label="经销商代码" width="100"></el-table-column>             
                <el-table-column label="终端客户联络人" align="center" prop="agentCode">
                    <template slot-scope="scope">
                        <p v-html="scope.row.userInfo.split('\n').map(item => `<p >${item}</p>`).join('')"></p>
                        <!-- <p v-html="scope.row.userInfo" style="white-space:pre-wrap"></p> -->
                        <!-- <pre><p v-html="scope.row.userInfo"></p></pre> -->
                        <!-- <p v-html="scope.row.userInfo.replace(/\n/g,'<br/>')"></p> -->
                    </template>
                </el-table-column>
                
                <el-table-column prop="mpnId" align="center" label="MPN ID"  width="100"></el-table-column>
                <el-table-column prop="cmr" align="center"  label="CMR"  width="200"></el-table-column> 
                <el-table-column prop="selfDefine" align="center"  label="自定义信息" >
                    <template slot-scope="scope" >
                        <el-button type="text" @click="onEditDefineClick(scope.row)">{{scope.row.selfDefine?scope.row.selfDefine:'无'}}</el-button>
                    </template>
                </el-table-column>     
                
                      
            </el-table>

            <div class="tabListPage">
                <el-pagination @size-change="handleSizeChange" 
                            @current-change="handleCurrentChange" 
                            :current-page="currentPage" 
                            :page-sizes="pageSizes" 
                            :page-size="PageSize" layout="total, sizes, prev, pager, next, jumper" 
                            :total="totalCount">
                </el-pagination>
            </div>

            <el-dialog title="编辑自定义信息" :visible="editDefineDialogVisible" width="60%"
                            :modal-append-to-body='false'
                            :close-on-click-modal='false'
                            @close="editDefineDialogVisible = false" 
                            append-to-body>
                <el-form :model="defineForm" inline >
                    <el-row>
                        <el-form-item label="自定义信息">
                            <!-- <el-input v-model="defineForm.define" class="text-width"></el-input> -->
                            <el-input v-model="defineForm.define" size="medium" :rows="8" type="textarea"
                                    autocomplete="off" placeholder="请输入自定义信息" style="width:800px"
                                    ></el-input>
                        </el-form-item>
                    </el-row>  
                                                          
            </el-form>
            <div slot="footer" style="display:flex;justify-content:center;margin-top:20px;">
                        <el-button @click="editDefineDialogVisible = false">关闭</el-button>
                        <el-button style="margin-left:20px;" type="primary" @click="onSaveDefine">保存</el-button>
                    </div> 
            
		    </el-dialog>

        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
// import { getLatestMonthDateArrayByDate } from "@/utils/time";
import { getToken } from "@/utils/auth";
import {ZC_SaveAgentDefine} from "@/api/zc";


export default {
    name: 'baseform',
    components: {

      },
    computed: {
        ...mapGetters(['agentList'])
    },
    data() {
        return {
            form: {    
                key:'',
            },

            // 默认显示第几页
            currentPage:1,
            // 总条数，根据接口获取数据长度(注意：这里不能为空)
            totalCount:0,
            // 个数选择器（可修改）
            pageSizes:[20,50,100],
            // 默认每页显示的条数（可修改）
            PageSize:50,

            editDialogVisible:false,
            editDefineDialogVisible:false,

            defineForm:{
                define:'',
            },
            curItem:{},
        };
    },

    async mounted() {
        this.onQuery();
    },


    methods: {
        async onEditDefineClick(item){
            this.curItem=item;   
            this.defineForm.define=item.selfDefine;         
            this.editDefineDialogVisible=true;
        },

       async onQuery(){
        // console.log('form',this.form)
        const {key} = this.form;
        
        await this.$store.dispatch("zc/agentList", {
            key,
        }).then(res=>{
            this.$refs.Table.doLayout();
            this.totalCount=this.agentList.length
            this.currentPage=1
            
        });

       },

       // 每页显示的条数
        handleSizeChange(val) {
        // 改变每页显示的条数 
        this.PageSize=val
        // 注意：在改变每页显示的条数时，要将页码显示到第一页
        this.currentPage=1
        },
        // 显示第几页
        handleCurrentChange(val) {
            // 改变默认的页数
            this.currentPage=val
        },

        async onSaveDefine(){
            const {define} = this.defineForm;
            var id ='';
            if (this.curItem && this.curItem.id){
                id=this.curItem.id;
            }
           
            await ZC_SaveAgentDefine({userId: getToken(),id,define:this.defineForm.define}).then(()=>{
                this.onQuery();
                this.$message.success('保存成功');
                this.editDefineDialogVisible=false;
            });
        },

    }
};
</script>

<style scoped>
</style>